import { DateInput } from 'browser/components/atomic-elements/atoms/input/date-input/date-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const DateField = LabelFieldFactory({ InputComponent: DateInput })
export {DateField}
